// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"08aec53ecbfbd88a9da9","293":"2b83612e36737774d185","454":"8f2b2c2e74d10dcba754"}[chunkId] + ".js";
};